import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { UserService } from "../shared/services/user.service";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "[appSearchBar]",
  templateUrl: "./search-bar.component.html",
})
export class SearchBarComponent implements OnInit, OnDestroy {
  searchForm: FormGroup;
  private paramSubscription: Subscription;
  private destroy$ = new Subject<void>();

  private formValues = {
    term: null,
  };

  constructor(private formBuilder: FormBuilder, private router: Router) {}

  ngOnInit() {
    this.buildForm();

    this.paramSubscription = this.router.routerState.root.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        if (!params["term"]) this.formValues.term = null;
        else this.formValues.term = params["term"];

        this.searchForm.setValue(this.formValues);
      });
  }

  onSubmit(updatedFormValues: any) {
    this.formValues = updatedFormValues;
    this.router.navigate(["students"], {
      queryParams: { term: this.formValues.term },
    });
  }

  private buildForm() {
    this.searchForm = this.formBuilder.group({
      term: [this.formValues.term],
    });
  }

  ngOnDestroy() {
    if (this.paramSubscription) this.paramSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
